import React, { useState } from 'react';
import '../css/style.css'; // Previously: './Contact.css';

const Contact = () => {
    return (
        <div className="contact-page">
            {/* Header slika */}
            <div
                className="header-image"
                style={{
                    backgroundImage: `url(/images/default.jpg)`, // Možete zameniti sa odgovarajućom slikom
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '300px',
                    width: '100vw',
                }}
            >
                <div className="page-title-contact-container">
                    <h1 className="page-title-contact">Contact Us</h1>
                </div>
            </div>

            {/* Centralna kontakt sekcija */}
            <div className="contact-content-box">
                <div className="contact-details">
                    <h2>Contact Information</h2>
                    <p><strong>Email:</strong> example@tooristico.com</p>
                    <p><strong>Phone:</strong> +1 (123) 456-7890</p>
                    <p><strong>Address:</strong> 123 Main Street, City, Country</p>
                    <p>Feel free to reach out for any questions!</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
